import React, { Component } from "react";
import translate from "../translations/translations.wrapper.jsx";
import "./Settings.scss";
import { Button, ButtonType } from "components/common/Button.component";

export class SettingsButtonsBarView extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <footer className={"fixed-bottom px-5 mb-4 task-action-buttons " + this.props.containerFooterStyling}>
                <div className={this.props.containerInnerStyling}>
                    <div className="row">
                        <div className="col-md-6 ml-auto d-flex align-items-center">
                            {this.props.hasBackButton &&
                                <Button type={ButtonType.SECONDARY}
                                    onClick={this.props.backCallback}
                                    disabled={!this.props.backCallback}
                                    text={this.props.translate("settings.back")}
                                />
                            }
                            {this.props.moreActionsButton}
                        </div>

                        <div className="col-md-6 ms-auto d-flex gap-8 align-items-center justify-content-end">
                            {!this.props.hideSave &&
                                <Button type={ButtonType.PRIMARY}
                                        onClick={this.props.okCallback}
                                        disabled={!this.props.okEnabled}
                                        dataTestId={"__tst_save"}
                                        text={this.props.translate("settings.save")}
                                />
                            }
                            {!this.props.hideCancel &&
                                <Button type={ButtonType.SECONDARY}
                                        onClick={this.props.cancelCallback}
                                        disabled={!this.props.cancelEnabled}
                                        dataTestId={"__tst_cancel"}
                                        text={this.props.translate("settings.cancel")}
                                />
                            }
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

const withTranslations = translate(SettingsButtonsBarView);
export default withTranslations;